export const LEGAL_GENERAL_INFO: string = `

### <!--= ++sectionIndex -->. General Information

#### <!--= sectionIndex -->.1. About Your Privacy

The following notes provide a simple overview of what happens to your personal data when you visit our website. Personal data refers to any data that can personally identify you. Detailed information on the subject of data protection can be found in our privacy policy listed below.

This privacy policy applies to the personal data that we stores about you or collects from you when you visit our platform or use our services. In the following, we explain why and how we process your personal data.

#### <!--= sectionIndex -->.2. Data Collection on Our Website

**Who is Responsible for Data Collection on this Website?**
The data processing on this website is carried out by the website operator. You can find their contact details in the imprint of this website or further below.

**How do We Collect Your Data?**
Your data is collected in two ways. Firstly, you may provide us with the data. This could be data that you enter into a contact form, for example. Secondly, other data is automatically collected by our server systems when you visit our website. This is primarily technical data (e.g., internet browser, operating system, or time of the page request). This data is collected automatically as soon as you enter our website.

**What do We Use Your Data for?**
A part of the data is collected to ensure error-free provision of the website. Other data can be used to analyze your user behavior.

**What Rights do You Have Regarding Your Data?**
You have the right to receive information about the origin, recipient, and purpose of your stored personal data free of charge at any time. You also have the right to request the correction, blocking, or deletion of this data. You can contact us at the address given in the imprint at any time for this purpose and for further questions on the subject of data protection. Furthermore, you have the right to lodge a complaint with the competent supervisory authority.

#### <!--= sectionIndex -->.3. Types Of Cookies

Our website uses the following categories of cookies:

- Essential Cookies: These are required for basic website functions and cannot be deactivated.
- Functionality Cookies: They ensure enhanced functionality and personalization on our site.
- Social Media Cookies: These allow for interaction with social media networks.
- Analytical Cookies: These help us improve our website by collecting and reporting information on its usage.

Learn more and manage your cookie preferences at our <button class="btn btn-link p-0" routerLink="cookies-usage">Cookies Usage</button> page.

This website uses optional analytical and social media cookies for statistical and marketing purposes. These cookies are not essential for the functioning of the site but they help us understand user interaction, allowing us to enhance your browsing experience and the services we offer. In compliance with the GDPR / DSGVO, these cookies will only be activated after your explicit consent.

#### <!--= sectionIndex -->.4. Personalize Your Cookie

You can personalize your cookie preferences at any time by visiting our <button class="btn btn-link p-0" routerLink="cookies-usage">Cookies Usage</button> page.
`;
